import React, { useEffect, useState } from 'react';

const PaymentMethodModal = ({ isOpen, onClose, onSelect, loading }) => {
  const [methods, setMethods] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    const fetchPaymentMethods = async () => {
      try {
        setFetching(true);
        setError('');
        const response = await fetch('https://nqa1.in/api/payment/method/list');
        const data = await response.json();

        if (data.success && data.data) {
          setMethods(data.data);
        } else {
          setError('Failed to fetch payment methods');
        }
      } catch (err) {
        console.error('Error fetching payment methods:', err);
        setError('Unable to load payment methods');
      } finally {
        setFetching(false);
      }
    };

    fetchPaymentMethods();
  }, [isOpen]);

  if (!isOpen) return null;

  const availableMethods = methods.filter(m => m.status === 'available');
  const unavailableMethods = methods.filter(m => m.status !== 'available');

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: 12,
        padding: 30,
        maxWidth: 500,
        width: '100%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ margin: 0 }}>Select Payment Method</h2>
          <button
            onClick={onClose}
            disabled={loading || fetching}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 24,
              cursor: 'pointer',
              color: '#999'
            }}
          >
            ✕
          </button>
        </div>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#d32f2f',
            padding: 12,
            borderRadius: 8,
            marginBottom: 20,
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {fetching ? (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <p>Loading payment methods...</p>
          </div>
        ) : (
          <>
            {availableMethods.length > 0 ? (
              <>
                <p style={{ color: '#666', marginBottom: 15 }}>Available payment methods:</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
                  {availableMethods.map(method => (
                    <button
                      key={method.key}
                      onClick={() => onSelect(method.key)}
                      disabled={loading || fetching}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 15,
                        padding: 15,
                        border: '2px solid #ddd',
                        borderRadius: 8,
                        background: 'white',
                        cursor: loading || fetching ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease',
                        opacity: loading || fetching ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => {
                        if (!loading && !fetching) {
                          e.currentTarget.style.borderColor = '#667eea';
                          e.currentTarget.style.background = '#f5f7ff';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = '#ddd';
                        e.currentTarget.style.background = 'white';
                      }}
                    >
                      <img
                        src={method.image}
                        alt={method.name}
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: 'contain'
                        }}
                      />
                      <span style={{ flex: 1, textAlign: 'left', fontWeight: 500 }}>
                        {method.name}
                      </span>
                      {loading ? (
                        <span style={{ color: '#667eea' }}>Processing...</span>
                      ) : (
                        <span style={{ color: '#667eea' }}>→</span>
                      )}
                    </button>
                  ))}
                </div>
              </>
            ) : !fetching && (
              <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                No payment methods available
              </div>
            )}

            {unavailableMethods.length > 0 && (
              <div style={{
                background: '#f5f5f5',
                padding: 15,
                borderRadius: 8,
                marginTop: 15
              }}>
                <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: 13 }}>
                  Coming soon:
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {unavailableMethods.map(method => (
                    <div
                      key={method.key}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        opacity: 0.5
                      }}
                    >
                      <img
                        src={method.image}
                        alt={method.name}
                        style={{
                          width: 40,
                          height: 40,
                          objectFit: 'contain'
                        }}
                      />
                      <span style={{ fontSize: 13, color: '#999' }}>
                        {method.name} (Coming Soon)
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <button
              onClick={onClose}
              disabled={loading || fetching}
              style={{
                width: '100%',
                marginTop: 20,
                padding: 12,
                border: '1px solid #ddd',
                borderRadius: 8,
                background: 'white',
                cursor: loading || fetching ? 'not-allowed' : 'pointer',
                opacity: loading || fetching ? 0.6 : 1
              }}
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodModal;
